export const resetScheduling = () => state => {
  if (state.scheduling.done && !state.scheduling.sending) {
    return {
      ...state,
      scheduling: {
        ...state.scheduling,
        done: false,
      },
    };
  }
};
